import { render, staticRenderFns } from "./view1.vue?vue&type=template&id=23a0a2b4&scoped=true&"
import script from "./view1.vue?vue&type=script&lang=js&"
export * from "./view1.vue?vue&type=script&lang=js&"
import style0 from "./view1.vue?vue&type=style&index=0&id=23a0a2b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a0a2b4",
  null
  
)

export default component.exports